/**
 * Tidio: no position/size overrides — widget follows Tidio dashboard (left/right, etc.).
 * Only hide/show for band-width popup + page scroll lock helpers.
 */
(function () {
  var SCROLL_LOCK_CLASS = 'cb-scroll-locked';

  function getTidioEl() {
    return document.getElementById('tidio-chat');
  }

  window.caratbeeSetTidioVisible = function (visible) {
    var el = getTidioEl();
    if (!el) {
      return;
    }
    if (visible) {
      el.style.removeProperty('visibility');
      el.style.removeProperty('opacity');
      el.style.removeProperty('pointer-events');
      return;
    }
    el.style.setProperty('visibility', 'hidden', 'important');
    el.style.setProperty('opacity', '0', 'important');
    el.style.setProperty('pointer-events', 'none', 'important');
  };

  /** @deprecated No-op — kept so extra-product.liquid does not error. */
  window.caratbeePinTidio = function () {};

  window.caratbeeLockPageScroll = function () {
    if (document.body.classList.contains(SCROLL_LOCK_CLASS)) {
      return;
    }
    var y = window.scrollY || window.pageYOffset || 0;
    document.body.dataset.cbScrollY = String(y);
    document.body.classList.add('no-scroll', SCROLL_LOCK_CLASS);
    document.body.style.position = 'fixed';
    document.body.style.top = '-' + y + 'px';
    document.body.style.left = '0';
    document.body.style.right = '0';
    document.body.style.width = '100%';
  };

  window.caratbeeUnlockPageScroll = function () {
    if (!document.body.classList.contains(SCROLL_LOCK_CLASS)) {
      return;
    }
    window.caratbeeForceUnlockPageScroll();
  };

  /** Clears band-popup scroll lock even if cb-scroll-locked class was lost out of sync. */
  window.caratbeeForceUnlockPageScroll = function () {
    var y = parseInt(document.body.dataset.cbScrollY || '0', 10) || 0;
    document.body.classList.remove('no-scroll', SCROLL_LOCK_CLASS);
    document.body.style.position = '';
    document.body.style.top = '';
    document.body.style.left = '';
    document.body.style.right = '';
    document.body.style.width = '';
    delete document.body.dataset.cbScrollY;
    if (y) {
      window.scrollTo(0, y);
    }
  };
})();
